<template>
<div class="main" @click.self="$emit('close')">
  <div class="box-modal">
    <span class="title">شناسایی دوعاملی</span>

    <div v-if="otp === 'ایمیل'" class="first-row">
      <span>کد ارسالی به ایمیل خود را وارد کنید</span>
      <div class="logo">
        <inline-svg :src="require('../../../../assets/icon/email.svg')"/>
        <span>zgoudarzi9148@gmail.com</span>
      </div>
      <custom-input type="email" placeholder="کد ارسالی" auth="auth" />
      <button @click="$emit('close')" class="blue-btn">تایید</button>
    </div>

    <div v-if="otp === 'پیامک'" class="first-row">
      <span>کد ارسالی به شماره تلفن خود را وارد نمایید</span>
      <div class="logo">
        <inline-svg :src="require('../../../../assets/icon/phoe.svg')"/>
        <span>0912-***-5689</span>
      </div>
      <custom-input type="email" placeholder="کد ارسالی" auth="auth" />
      <button @click="$emit('close')" class="blue-btn">تایید</button>
    </div>

<!--    <div v-if="otp === 'گوگل'" class="first-row">-->
<!--      <span>کد ارسالی به برنامه  google authenticator  خود را وارد نمایید</span>-->
<!--      <input type="text" class="public-input" placeholder="کد ارسالی">-->
<!--      <button @click="$emit('close')" class="blue-btn">تایید</button>-->
<!--    </div>-->

  </div>
</div>
</template>

<script>
import CustomInput from "../../../tools/custom-input";
export default {
  name: "otp-change-password-modal",
  components: {CustomInput},
  props:['otp']
}
</script>

<style lang="scss" scoped>
.main{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0,0.7);
  z-index: 10;

  .box-modal{
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding:28px;
    width: 367px;

    .first-row{
      display: flex;
      flex-direction: column;
      gap: 28px;

      span{
        text-align: right;
      }

      .logo{
        display: flex;
        justify-content: right;
        gap: 10px;
        align-items: center;

        span{
          font-size: 12px;
        }
      }
    }

    .title{
      font-size: clamp(14px , 2vw , 16px);
      color: #FFFFFF;
      font-weight: bold;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 28px;
    }
  }
}

@media (max-width: 500px) {
  .box-modal{
    width: 280px !important;
  }
}
</style>